const colorOptions = (theme = []) => {
  return (
    theme.map((color, idx) => {
    const postFix = ['(Primary)','(Secondary)','(Tertiary)', '', '']
    return {label: `${idx}: ${color} ${postFix[idx]}`, value: idx};
    })
  )
}

export default colorOptions;